import React from 'react'
import Superface from '../Superface'
import Swiper from 'swiper'
import {addClass} from '../kit'

export default class GalleryLarge extends React.Component{

    componentWillMount(){
        this.images_loaded  = 0
        this.setState({
            loaded : false
        })
    }

    initSlider(){
        
        if( this.swiper ) return
        
        addClass( this.slider, 'slider-' + this.props.i )
        const params = { 
            speed : 400, 
            loop : true,
            initialSlide : 0,
            loopAdditionalSlides : this.props.slides.length,
            loopedSlides : this.props.slides.length,
            slidesPerView : 'auto'
        }
        
        setTimeout( () => {
            this.swiper = new Swiper('.slider-' + this.props.i , params)
        }, 500)
        
        // mySwiper.on('slideChange', function () {

        // })
    }
    
    renderMedias(slides){
       return slides.map( (slide, i) => {
            // console.log('PATH ' + slide.path)
            // console.log('MODIFIED PATH ' + Superface.assetUrl(slide.path))
            return(
                <div key={i} className="swiper-slide">
                    <img alt="materials" src={Superface.assetUrl(slide.path)} onLoad={ () => {
                        this.images_loaded ++
                        // console.log( this.images_loaded + '/' + this.props.slides.length )
                        if( this.images_loaded === this.props.slides.length ){
                            this.setState({loaded : true})
                            this.initSlider()
                        }
                    }} />
                </div>
            )
        })
    }

    render(){
        return(

            <div style={{display:'block', padding : '17rem 0 0', backgroundColor:'white', position:'relative', width:'120vw'}}>
            
                <div style={{position:'absolute', left:'10vw', top:'17rem', width:'20vw', bottom:'0', backgroundColor:'white', zIndex:20}}>
                        <div style={{display:'flex', alignItems:'center', height:'100%', paddingLeft:'10vw'}}>
                            <div 
                                onClick={ () => { this.swiper.slidePrev() }} 
                                className="arrow" >
                                    <img src={require('../images/arrow-left.svg')} alt='arrow'/>
                            </div>
                            <div 
                                onClick={ () => { this.swiper.slideNext() }} 
                                className="arrow" >
                                    <img src={require('../images/arrow-right.svg')} alt='arrow'/>
                            </div>
                             
                        </div>
                </div>
                
                <div style={{position:'absolute', left:'30vw', top:'calc(17rem - 10vh)', right:'30vw', bottom:'-10vh', border: '10vh solid white', pointerEvents:'none', zIndex:20}}>
                    
                </div>
                
                <div ref={ slider => this.slider = slider } className="swiper-container swiper-large">
                    <div className="swiper-wrapper">
                        {this.renderMedias(this.props.slides)}
                    </div>
                </div>

            </div>
        )
    }
    
}


// WEBPACK FOOTER //
// ./src/components/_GalleryLarge.js